import React from 'react';
import { FileBarChart2, ArrowUpRight } from 'lucide-react';

/**
 * Chat renderer for shared native report views (attachment type
 * 'native_report_share'). The shared URL carries the complete report state —
 * filters, drill-down expansion, even scroll position — so opening it
 * restores the exact view the sender was looking at.
 */
export default function NativeReportShareMessage({ message }) {
  const attachment = (message.attachments || []).find((att) => att.type === 'native_report_share');
  if (!attachment || !attachment.url) return null;

  const { url, reportCategory, reportTitle, subtitle, timestamp } = attachment;
  const senderName = message.user?.name || message.user?.id || 'Someone';

  const openView = () => {
    try {
      const parsed = new URL(url, window.location.origin);
      // same-app link: navigate relative so it works on any host/env
      window.location.href = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch (e) {
      window.location.href = url;
    }
  };

  return (
    <div className="str-chat__message str-chat__message--regular" style={{ padding: '4px 8px' }}>
      <div
        style={{
          maxWidth: 420,
          background: 'var(--lodge-white, #fff)',
          border: '1px solid var(--lodge-onyx-100, #E8E8F0)',
          borderLeft: '3px solid var(--lodge-orange-400, #FF7A00)',
          borderRadius: 12,
          padding: '12px 14px',
          boxShadow: '0 1px 3px rgba(15,15,17,.08)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
          <FileBarChart2 size={16} style={{ color: 'var(--lodge-orange-500, #E56E00)' }} />
          <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--lodge-onyx-400, #72727F)' }}>
            Shared report view
          </span>
        </div>
        <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--lodge-onyx-900, #0F0F11)' }}>
          {reportCategory ? `${reportCategory} · ` : ''}{reportTitle || 'Report'}
        </div>
        {subtitle ? (
          <div style={{ fontSize: 12, color: 'var(--lodge-onyx-500, #52525F)', marginTop: 2 }}>{subtitle}</div>
        ) : null}
        <div style={{ fontSize: 11, color: 'var(--lodge-onyx-400, #72727F)', marginTop: 6 }}>
          {senderName} shared this exact view{timestamp ? ` · ${new Date(timestamp).toLocaleString()}` : ''} — filters,
          drill-downs and position included.
        </div>
        <button
          type="button"
          onClick={openView}
          style={{
            marginTop: 10,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 12.5,
            fontWeight: 600,
            color: '#fff',
            background: 'var(--lodge-onyx-900, #0F0F11)',
            border: 'none',
            borderRadius: 8,
            padding: '7px 12px',
            cursor: 'pointer',
          }}
        >
          Open exact view
          <ArrowUpRight size={14} />
        </button>
      </div>
    </div>
  );
}
